module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-end-circle-fill-87970d74.svg";